import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import image_croix from "../Pages/image/croix.png";
import TrainingService from '../../Service/TrainingService';

const TrainingConditions = ({ training, conditions }) => {
    const [editMode, setEditMode] = useState(false);
    const [textAreaValue, setTextAreaValue] = useState('');
    const token = sessionStorage.getItem('token');

    // Convertir le HTML en texte brut au moment de l'édition
    useEffect(() => {
        if (training.public) {
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = training.public;  // Le texte initial est en HTML
            setTextAreaValue(tempDiv.innerText);  // Convertir le HTML en texte brut pour l'édition
        }
    }, [training.public]);

    const handleEditClick = () => {
        setEditMode(true);
    };

    const handleInputChange = (event) => {
        setTextAreaValue(event.target.value);
    };

    const handleSaveClick = async () => {
        // Sauvegarder le texte modifié dans l'objet training
        training.public = textAreaValue;  // Le texte modifié reste en texte brut

        try {
            let response;
            if (training.modif) {
                response = await TrainingService.putModifTraining(training);
            } else {
                response = await TrainingService.postModifTraining(training);
            }
            window.location.reload();
            console.log(response);
        } catch (error) {
            console.log("Error: " + error);
        }
        setEditMode(false);
    };

    // Sépare le texte en plusieurs lignes en utilisant les retours à la ligne (\n)
    const getLinesWithIcons = (text) => {
        return text.split('\n').map((line, index) => (
            <div className="line" key={index}>
                <img src={image_croix} alt="Icone croix" className="section-icon" />
                <p style={{ display: 'inline', marginLeft: '10px' }}>{line}</p>
            </div>
        ));
    };

    return (
        <div className="section-content">
            Pour entrer en formation le candidat doit :<br /><br />
            {editMode ? (
                <textarea
                    value={textAreaValue}
                    onChange={handleInputChange}
                    rows={10}
                    style={{ width: '100%' }}
                />
            ) : (
                // Diviser le texte en plusieurs lignes et ajouter l'icône pour chaque ligne
                <div>
                    {getLinesWithIcons(training.public)}
                </div>
            )}
            {editMode ? (
                <button
                    className="inscription-button modif_button"
                    onClick={handleSaveClick}
                    style={{ right: 0 }}
                >
                    Enregistrer
                </button>
            ) : (
                token === '' && (
                    <button
                        className="inscription-button modif_button"
                        onClick={handleEditClick}
                        style={{ marginLeft: '10px' }}
                    >
                        Modifier
                    </button>
                )
            )}
        </div>
    );
};

export default TrainingConditions;